/**
 * Tap/click toggle for the level cards' perk overlay. Desktop mouse hover is
 * handled entirely in CSS (see rewards-levels.css); this covers touch and
 * keyboard, and closes any other open card first.
 *
 * NOT wired yet: highlighting the shopper's actual current tier. Each <li>
 * already carries data-rewards-level-name so a future pass can compare it
 * against the tier name scraped in rewards-activity.js and toggle
 * .is-current-level — holding off until that scrape is confirmed against
 * real Yotpo output (see rewards-activity.js header comment).
 */
(function () {
  function closeCard(card) {
    var toggle = card.querySelector('[data-rewards-level-toggle]');
    card.classList.remove('is-revealed');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function openCard(card) {
    var toggle = card.querySelector('[data-rewards-level-toggle]');
    card.classList.add('is-revealed');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-rewards-level-toggle]');
    var openCards = document.querySelectorAll('.rewards-levels__card.is-revealed');

    if (!toggle) {
      openCards.forEach(closeCard);
      return;
    }

    var card = toggle.closest('.rewards-levels__card');
    var wasOpen = card.classList.contains('is-revealed');

    openCards.forEach(closeCard);

    if (!wasOpen) openCard(card);
  });

  // On hover-capable devices, a click can leave a card open via JS after the
  // mouse moves off it — CSS :hover no longer applies but .is-revealed still
  // does, so it stays visually stuck open. Close it on mouseleave so click
  // and hover state never disagree.
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.rewards-levels__card').forEach(function (card) {
      card.addEventListener('mouseleave', function () {
        closeCard(card);
      });
    });
  }
})();
